/**
 * @description Format meta data.
 * @param {Array<any>} metaDataList - raw meta data list
 * @returns Return updated array.
 */
export const formatMetaData = (
  metaDataList: any[],
  category: string
): any[] => {
  try {
    if (Array.isArray(metaDataList) && metaDataList?.length > 0) {
      return metaDataList
        ?.filter(({ fieldCategory }: any) => fieldCategory == category)
        ?.map(
          ({
            fieldName,
            dataType,
            valueType,
            valueSource,
            dataTypeId,
            fieldCategory,
            id,
            valueTypeId
          }) => ({
            label: fieldName,
            value: fieldName,
            dataType: dataType,
            valueType: valueType,
            dataTypeId: dataTypeId,
            fieldCategory: fieldCategory,
            valueTypeId: valueTypeId,
            id: id,
            valueSource: Array.isArray(valueSource?.split(","))
              ? valueSource
                  ?.split(",")
                  .map((item: string) => ({
                    label: item.trim(),
                    value: item.trim(),
                  }))
              : [],
          })
        );
    } else return [];
  } catch (e) {
    return [];
  }
};
